import { render, staticRenderFns } from "./Func11DetalheServico.vue?vue&type=template&id=2741c28a"
import script from "./Func11DetalheServico.vue?vue&type=script&lang=js"
export * from "./Func11DetalheServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports